import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import ResultsContainer from './ResultsContainer'

export default class Search extends Component {
	constructor(props) {
    super(props)
    this.state = { active: false }
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
  }

  handleOpen() {
    this.setState({ active: true })
  }
  handleClose() {
    this.setState({ active: false })
  }

	render() {
		return (
      <ResultsContainer active={this.state.active} handleOpen={this.handleOpen} handleClose={this.handleClose} {...this.props} />
		)
	}
}

if (document.getElementById('modal-root') !== null) {
	ReactDOM.render(<Search searchBaseUrl={'searchindex'} searchPath='' />, document.getElementById('modal-root'))
}

if (document.getElementById('root') !== null) {
  ReactDOM.render(<Search searchBaseUrl={'sectionindex'} searchPath={document.getElementById('root').getAttribute('data-parent')} inline={true} />, document.getElementById('root'))
}
